import { acl, Permission } from '@/modules/acl/aclService';

export const permissionDirective = {
  mounted(el: HTMLElement, binding: { value: Permission }) {
    if (!acl.hasPermission(binding.value)) {
      el.remove();
    }
  },
};
